import {styled} from 'external/material'
import DashboardContentTabButton from './DashboardContentTabButton'

const StyledDashboardContentTabs = styled('div')(dashboardContentTabStyles)

export default function DashboardContentTabs(props) {
    return(
        <StyledDashboardContentTabs {...props}>
            <DashboardContentTabButton tab='messages' />
            <DashboardContentTabButton tab='recent-activities' />
            <DashboardContentTabButton tab='videos' />
        </StyledDashboardContentTabs>
    )
}


function dashboardContentTabStyles(){
    return {
        display: 'flex',
        justifyContent: 'flex-start',
        '& > div': {
            marginLeft: 10,
            '&:first-of-type': {
                marginLeft: 0
            }
        }
    }
}
